export default "__VITE_ASSET__DhWdd3in__"